/* SoulGlow Effekte: Sternenhimmel, echter Mond (Karten: NASA's Scientific Visualization Studio), Mondphasen,
   Zähler, Sternbild, Licht, Tilt. Alles startet erst, wenn es sichtbar wird. "Bewegung reduzieren" wird respektiert. */
(function(){
  if (window.SGFX) { window.SGFX.init(document); return; }
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
  var small = Math.min(screen.width, innerWidth) < 750;
  /* Handy/Tablet: weniger Pixel, weniger Bilder pro Sekunde, keine Dauer-Leucht-Effekte */
  var lite = small || !fine;
  var DPR = Math.min(window.devicePixelRatio || 1, lite ? 1.5 : 2);
  if (lite && !document.getElementById('sgfx-lite')){
    var st = document.createElement('style'); st.id = 'sgfx-lite';
    st.textContent = '.sgh__btn,.sgk__btn,.sgj__btn,.sgf__form button[type=submit],.shopify-payment-button__button--unbranded,.sgt__btn{animation:none!important}'
      + '.sgj__now{-webkit-backdrop-filter:none!important;backdrop-filter:none!important}';
    (document.head || document.documentElement).appendChild(st);
  }
  var BASE = 'https://cdn.shopify.com/s/files/1/0574/6370/1643/files/';
  var SRC = { tex: BASE + (small ? 'sg-mond-textur-2k_1024x.jpg' : 'sg-mond-textur-2k.jpg') + '?v=1790098058',
              dem: BASE + 'sg-mond-relief.jpg?v=1790098034' };

  function once(el, cb, margin, thr){
    if (!('IntersectionObserver' in window)) { cb(); return; }
    var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ io.disconnect(); cb(); } }); },
      { rootMargin: margin || '0px', threshold: thr || 0 });
    io.observe(el);
  }
  function watch(el, cb){
    if (!('IntersectionObserver' in window)) { cb(true); return; }
    new IntersectionObserver(function(es){ cb(es[es.length-1].isIntersecting); }).observe(el);
  }

  /* ---------- Mond ---------- */
  var data = null;
  function load(src){ return new Promise(function(res, rej){ var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function(){ res(i); }; i.onerror = rej; i.src = src; }); }
  function px(img){ var c = document.createElement('canvas'); c.width = img.naturalWidth; c.height = img.naturalHeight;
    var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0);
    return { w: c.width, h: c.height, d: x.getImageData(0, 0, c.width, c.height).data }; }
  function maps(){
    if (!data) data = Promise.all([load(SRC.tex), load(SRC.dem)]).then(function(r){
      var t = px(r[0]), h = px(r[1]), L = new Float32Array(t.w*t.h), H = new Float32Array(h.w*h.h), i, k;
      for (i = 0; i < L.length; i++){ k = i*4; L[i] = (.30*t.d[k] + .59*t.d[k+1] + .11*t.d[k+2]) / 255; }
      for (i = 0; i < H.length; i++) H[i] = h.d[i*4] / 255;
      return { L: L, tw: t.w, th: t.h, H: H, hw: h.w, hh: h.h };
    });
    return data;
  }
  var stops = [0, .05, .22, .50, .78, 1],
      cols = [[13,17,40],[30,30,44],[98,87,70],[176,158,124],[232,216,181],[255,250,236]],
      LUT = new Uint8ClampedArray(256*3);
  (function(){ for (var i = 0; i < 256; i++){ var v = i/255, j = 0; while (j < stops.length-2 && v > stops[j+1]) j++;
    var f = (v - stops[j]) / (stops[j+1] - stops[j]); for (var c = 0; c < 3; c++) LUT[i*3+c] = cols[j][c] + (cols[j+1][c] - cols[j][c]) * f; } })();

  function moonView(canvas, opt){
    opt = Object.assign({ light: [.62,-.10,.78], rot: 0, bump: 1, earth: .02, lo: .04, hi: .62, gam: 1.25, expo: .9 }, opt || {});
    var ctx = canvas.getContext('2d'), N, img, geo, alb, hgt, M = null;
    var lastRot = null;
    function setup(){
      N = Math.max(64, Math.round(canvas.clientWidth * DPR));
      canvas.width = canvas.height = N; img = ctx.createImageData(N, N);
      var R = N/2 - 1, cnt = 0, x, y, nx, ny, r2;
      for (y = 0; y < N; y++) for (x = 0; x < N; x++){ nx = (x + .5 - N/2) / R; ny = (y + .5 - N/2) / R; if (nx*nx + ny*ny < 1.004) cnt++; }
      geo = new Float32Array(cnt * 7); var k = 0;
      for (y = 0; y < N; y++) for (x = 0; x < N; x++){
        nx = (x + .5 - N/2) / R; ny = (y + .5 - N/2) / R; r2 = nx*nx + ny*ny;
        if (r2 < 1.004){ var nz = Math.sqrt(Math.max(0, 1 - r2));
          geo[k] = y*N + x; geo[k+1] = nx; geo[k+2] = ny; geo[k+3] = nz; geo[k+4] = Math.atan2(nx, nz); geo[k+5] = Math.asin(Math.max(-1, Math.min(1, -ny))); geo[k+6] = Math.sqrt(r2); k += 7; }
      }
      alb = new Float32Array(N*N); hgt = new Float32Array(N*N); lastRot = null;
    }
    function draw(){
      if (!M) return;
      var L = M.L, tw = M.tw, th = M.th, H = M.H, hw = M.hw, hh = M.hh, d = img.data, TAU = Math.PI*2, k, i;
      var S = opt.light, sl = Math.hypot(S[0], S[1], S[2]), sx = S[0]/sl, sy = S[1]/sl, sz = S[2]/sl;
      /* Karten nur neu abtasten, wenn sich die Drehung aendert (Phasenlauf braucht nur neues Licht) */
      if (lastRot !== opt.rot){ lastRot = opt.rot;
      for (k = 0; k < geo.length; k += 7){
        i = geo[k]; var u = ((geo[k+4] + opt.rot) / TAU + .5) % 1; if (u < 0) u += 1; var v = .5 - geo[k+5] / Math.PI;
        var fx = u*tw - .5, fy = Math.min(th - 1.001, Math.max(0, v*th - .5)), x0 = Math.floor(fx), y0 = Math.floor(fy), ax = fx - x0, ay = fy - y0;
        var xa = (x0 + tw) % tw, xb = (x0 + 1) % tw, r0 = y0*tw, r1 = (y0 + 1)*tw;
        alb[i] = (L[r0+xa]*(1-ax) + L[r0+xb]*ax)*(1-ay) + (L[r1+xa]*(1-ax) + L[r1+xb]*ax)*ay;
        var gx = u*hw - .5, gy = Math.min(hh - 1.001, Math.max(0, v*hh - .5)), g0 = Math.floor(gx), h0 = Math.floor(gy), bx = gx - g0, by = gy - h0;
        var ga = (g0 + hw) % hw, gb = (g0 + 1) % hw, q0 = h0*hw, q1 = (h0 + 1)*hw;
        hgt[i] = (H[q0+ga]*(1-bx) + H[q0+gb]*bx)*(1-by) + (H[q1+ga]*(1-bx) + H[q1+gb]*bx)*by;
      } }
      var K = opt.bump * N * 0.012;
      for (k = 0; k < geo.length; k += 7){
        i = geo[k]; var nx = geo[k+1], ny = geo[k+2], nz = geo[k+3], rr = geo[k+6], x = i % N;
        var hl = hgt[x > 0 ? i-1 : i], hr = hgt[x < N-1 ? i+1 : i], hu = i >= N ? hgt[i-N] : hgt[i], hd = i + N < N*N ? hgt[i+N] : hgt[i];
        var Nx = nx - (hr - hl)*K*nz, Ny = ny - (hd - hu)*K*nz, Nz = nz, l = Math.hypot(Nx, Ny, Nz) || 1; Nx /= l; Ny /= l; Nz /= l;
        var mu0 = Math.max(0, Nx*sx + Ny*sy + Nz*sz), mu = Math.max(.03, nz);
        var lum = .8*(2*mu0/(mu0 + mu)) + .2*mu0;
        var a = Math.pow(Math.min(1, Math.max(0, (alb[i] - opt.lo) / (opt.hi - opt.lo))), opt.gam);
        var val = Math.min(1, Math.max(a*Math.min(1.15, lum)*opt.expo, opt.earth*a*nz));
        var c = Math.round(val*255)*3, o = i*4, edge = Math.min(1, Math.max(0, (1 - rr)*N/2 + .5));
        d[o] = LUT[c]; d[o+1] = LUT[c+1]; d[o+2] = LUT[c+2]; d[o+3] = 255*edge;
      }
      ctx.putImageData(img, 0, 0);
    }
    setup();
    var lastW = canvas.clientWidth;
    addEventListener('resize', function(){ if (Math.abs(canvas.clientWidth - lastW) > 8){ lastW = canvas.clientWidth; setup(); draw(); } });
    var api = { set: function(o){ Object.assign(opt, o); draw(); }, draw: draw };
    api.ready = maps().then(function(m){ M = m; draw(); return api; });
    return api;
  }
  function turnIn(v){ if (reduce || lite) return; var t0 = performance.now(), D = 2600;
    (function f(now){ var k = Math.min(1, (now - t0) / D), e = 1 - Math.pow(1 - k, 3); v.set({ rot: -.35*(1 - e) }); if (k < 1) requestAnimationFrame(f); })(t0); }
  function parseLight(s, d){ if (!s) return d; var p = s.split(',').map(Number); return p.length === 3 ? p : d; }

  function initMoon(canvas){
    var wrap = canvas.closest('[data-sg-moon-wrap]');
    once(canvas, function(){
      var start = function(){
        var v = moonView(canvas, { light: parseLight(canvas.getAttribute('data-light'), [.62,-.10,.78]) });
        v.ready.then(function(){ canvas.classList.add('is-on'); if (wrap) wrap.classList.add('is-ready'); if (canvas.hasAttribute('data-turn')) turnIn(v); })
          .catch(function(){ if (wrap) wrap.classList.add('is-failed'); });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1200 }); else setTimeout(start, 60);
    }, '300px');
  }

  function initPhases(canvas){
    var lbl = document.getElementById(canvas.getAttribute('data-label'));
    var names = [[.03,'Neumond'],[.22,'Zunehmende Sichel'],[.28,'Erstes Viertel'],[.47,'Zunehmender Mond'],[.53,'Vollmond'],[.72,'Abnehmender Mond'],[.78,'Letztes Viertel'],[.97,'Abnehmende Sichel'],[1.01,'Neumond']];
    once(canvas, function(){
      var v = moonView(canvas, { light: [0,0,-1], earth: .05 }), vis = true, last = 0, t0 = performance.now();
      watch(canvas, function(on){ vis = on; });
      v.ready.then(function(){
        canvas.classList.add('is-on');
        (function ph(now){
          if (reduce || (vis && now - last > (lite ? 80 : 33))){
            last = now; var p = reduce ? .5 : ((now - t0) / 12000) % 1, e = 2*Math.PI*p;
            v.set({ light: [Math.sin(e), -.04, -Math.cos(e)] });
            if (lbl) for (var j = 0; j < names.length; j++){ if (p < names[j][0]){ lbl.textContent = names[j][1]; break; } }
          }
          if (!reduce) requestAnimationFrame(ph);
        })(t0);
      }).catch(function(){});
    }, '200px');
  }

  /* ---------- Sternenhimmel ---------- */
  function initSky(canvas){
    var ctx = canvas.getContext('2d'), w, h, stars = [], shoot = null, run = false, looping = false, t0 = performance.now(), next = 2500;
    var dens = +(canvas.getAttribute('data-density') || 1);
    function size(){ var dpr = DPR; w = canvas.clientWidth; h = canvas.clientHeight;
      canvas.width = w*dpr; canvas.height = h*dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(Math.min(260, w*h/5200) * dens * (lite ? .75 : 1));
      stars = []; for (var i = 0; i < n; i++) stars.push({ x: Math.random()*w, y: Math.random()*h, r: Math.random()*1.3 + .2, p: Math.random()*6.28, s: .4 + Math.random()*1.6, g: Math.random() < .18 }); }
    size(); var lw = innerWidth; addEventListener('resize', function(){ if (innerWidth !== lw){ lw = innerWidth; size(); } });
    var lastF = 0;
    function loop(now){
      if (!run){ looping = false; return; }
      if (lite && now - lastF < 32){ requestAnimationFrame(loop); return; } lastF = now;
      var dt = (now - t0) / 1000; ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < stars.length; i++){ var s = stars[i];
        var a = reduce ? .7 : (.35 + .65*(.5 + .5*Math.sin(s.p + dt*s.s))), x = (s.x + dt*3) % w;
        ctx.globalAlpha = a; ctx.fillStyle = s.g ? '#efd48a' : '#fff'; ctx.beginPath(); ctx.arc(x, s.y, s.r, 0, 6.283); ctx.fill();
        if (s.r > 1.35){ var Lg = s.r*5*a; ctx.globalAlpha = a*.55; ctx.strokeStyle = ctx.fillStyle; ctx.lineWidth = .6;
          ctx.beginPath(); ctx.moveTo(x - Lg, s.y); ctx.lineTo(x + Lg, s.y); ctx.moveTo(x, s.y - Lg); ctx.lineTo(x, s.y + Lg); ctx.stroke(); } }
      if (!reduce){
        if (!shoot && now > next) shoot = { x: Math.random()*w*.7 + w*.2, y: Math.random()*h*.35, l: 0 };
        if (shoot){ shoot.l += 14; var Ls = Math.min(shoot.l, 140), sx = shoot.x - shoot.l, sy = shoot.y + shoot.l*.45;
          var gr = ctx.createLinearGradient(sx, sy, sx + Ls, sy - Ls*.45); gr.addColorStop(0, 'rgba(255,246,218,.95)'); gr.addColorStop(1, 'rgba(255,246,218,0)');
          ctx.globalAlpha = 1; ctx.strokeStyle = gr; ctx.lineWidth = 1.4; ctx.beginPath(); ctx.moveTo(sx, sy); ctx.lineTo(sx + Ls, sy - Ls*.45); ctx.stroke();
          if (shoot.l > w*.5){ shoot = null; next = now + 3500 + Math.random()*4000; } }
      }
      ctx.globalAlpha = 1;
      if (reduce){ looping = false; return; }
      requestAnimationFrame(loop);
    }
    watch(canvas, function(on){ run = on; if (on && !looping){ looping = true; requestAnimationFrame(loop); } });
  }

  /* ---------- Tiefe beim Scrollen ---------- */
  function initParallax(root){
    if (reduce) return;
    var layers = root.querySelectorAll('[data-sg-depth]'), vis = false, tick = false;
    watch(root, function(on){ vis = on; });
    function upd(){ tick = false; if (!vis) return; var r = root.getBoundingClientRect(), k = -r.top;
      for (var i = 0; i < layers.length; i++) layers[i].style.transform = 'translate3d(0,' + (k * +layers[i].getAttribute('data-sg-depth')).toFixed(1) + 'px,0)'; }
    addEventListener('scroll', function(){ if (!tick){ tick = true; requestAnimationFrame(upd); } }, { passive: true });
  }

  /* ---------- Zähler ---------- */
  function initCount(el){
    var txt = el.textContent.trim(), dec = txt.indexOf(',') > -1 ? txt.split(',')[1].length : 0;
    var target = parseFloat(txt.replace(/\./g, '').replace(',', '.'));
    if (!isFinite(target) || reduce) return;
    function fmt(n){ var s = n.toFixed(dec).split('.'); s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.'); return s.join(','); }
    /* Schnitte (mit Komma) zählen nur die Nachkommastellen hoch, z. B. 4,00 bis 4,98, nie ab 0 */
    var from = el.hasAttribute('data-sg-from') ? parseFloat(el.getAttribute('data-sg-from')) : (dec > 0 ? Math.floor(target) : 0);
    el.style.fontVariantNumeric = 'tabular-nums';
    /* Bis zum Sichtbarwerden steht die echte Zahl da; erst dann startet der Zähler */
    once(el, function(){
      el.textContent = fmt(from);
      var t0 = performance.now(), D = 1800;
      (function f(now){ var k = Math.min(1, (now - t0) / D), e = 1 - Math.pow(1 - k, 3); el.textContent = fmt(from + (target - from)*e); if (k < 1) requestAnimationFrame(f); else el.textContent = txt; })(t0);
    }, '0px', .6);
  }

  /* ---------- Sternbild ---------- */
  function initConst(svg){
    var pts = [[40,95],[92,78],[140,86],[180,104],[218,128],[262,138],[300,130],[330,108],[348,80],[362,62],[352,108]];
    var lines = [[0,1],[1,2],[2,3],[3,4],[4,5],[5,6],[6,7],[7,8],[8,9],[7,10]], NS = 'http://www.w3.org/2000/svg';
    lines.forEach(function(p, i){ var a = pts[p[0]], b = pts[p[1]], len = Math.hypot(b[0]-a[0], b[1]-a[1]), l = document.createElementNS(NS, 'line');
      l.setAttribute('x1', a[0]); l.setAttribute('y1', a[1]); l.setAttribute('x2', b[0]); l.setAttribute('y2', b[1]);
      l.style.setProperty('--len', len); l.style.transitionDelay = (.35 + i*.14) + 's'; svg.appendChild(l); });
    pts.forEach(function(p, i){ var c = document.createElementNS(NS, 'circle'); c.setAttribute('cx', p[0]); c.setAttribute('cy', p[1]);
      c.setAttribute('r', i === 3 ? 4 : 2.6); c.style.transitionDelay = (i*.12) + 's'; if (i === 3) c.setAttribute('class', 'is-main'); svg.appendChild(c); });
    once(svg, function(){ svg.classList.add('is-on'); }, '0px', .4);
  }

  /* ---------- Licht folgt der Hand ---------- */
  function initTorch(el){
    if (!fine || reduce) return;
    el.classList.add('has-torch');
    el.addEventListener('pointermove', function(e){ var r = el.getBoundingClientRect();
      el.style.setProperty('--sg-x', (e.clientX - r.left) + 'px'); el.style.setProperty('--sg-y', (e.clientY - r.top) + 'px'); });
  }

  /* ---------- Karten zum Anfassen ---------- */
  function initTilt(el){
    if (!fine || reduce) return;
    el.addEventListener('pointermove', function(e){ var r = el.getBoundingClientRect(), x = (e.clientX - r.left)/r.width - .5, y = (e.clientY - r.top)/r.height - .5;
      el.style.transform = 'perspective(800px) rotateY(' + (x*6).toFixed(2) + 'deg) rotateX(' + (-y*6).toFixed(2) + 'deg)';
      el.style.setProperty('--sg-g', (50 - x*100) + '%'); });
    el.addEventListener('pointerleave', function(){ el.style.transform = ''; });
  }

  function init(root){
    root = root || document;
    function each(sel, fn, flag){ root.querySelectorAll(sel).forEach(function(el){ if (el[flag]) return; el[flag] = 1; fn(el); }); }
    each('canvas[data-sg-sky]', initSky, '_sgSky');
    each('canvas[data-sg-moon]', initMoon, '_sgMoon');
    each('canvas[data-sg-phases]', initPhases, '_sgPh');
    each('[data-sg-parallax]', initParallax, '_sgPar');
    each('[data-sg-count]', initCount, '_sgCnt');
    each('svg[data-sg-const]', initConst, '_sgConst');
    each('[data-sg-torch]', initTorch, '_sgTorch');
    each('[data-sg-tilt]', initTilt, '_sgTilt');
    root.querySelectorAll('[data-sg-play]').forEach(function(el){ requestAnimationFrame(function(){ el.classList.add('is-play'); }); });
  }
  window.SGFX = { init: init, moonView: moonView };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
